import { apiSlice } from '../../app/api/apiSlice'
import { IBank } from '../../components/Dashboard/account-page/types'
import { urlConfig } from '../../config'

export const bankSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getBanks: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/banks/user`,
      providesTags: ['Banks'],
    }),

    listBanks: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/banks/list`,
      providesTags: ['BankList'],
    }),

    createBankAccount: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/banks`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Banks'],
    }),

    deleteBankAccount: build.mutation<any, { id: string }>({
      query: ({ id }) => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/banks/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Banks'],
    }),
  }),
})

export const {
  useGetBanksQuery,
  useListBanksQuery,
  useCreateBankAccountMutation,
  useDeleteBankAccountMutation,
} = bankSlice
